<div
	class="float-right noprint"
	*ngIf="!rsp.media.is_mobile"
	data-html2canvas-ignore
>
	<a
		(click)="print.download(element, title, 'p', svg)"
		href="javascript:void(0);"
		class="badge badge-secondary float-right ml-4"
	>
		Print
	</a>
</div>

<div
	class="float-right noprint"
	*ngIf="rsp.media.is_mobile"
	data-html2canvas-ignore
>
	<i
		data-bs-toggle="dropdown"
		*ngIf="rsp.media.is_mobile"
		class="fa fa-ellipsis-v download-svg-button"
		aria-hidden="true"
	></i>
	<ul class="dropdown-menu">
		<li>
			<a
				class="dropdown-item"
				(click)="print.download(element, title, 'p', svg)"
				>print</a
			>
		</li>
	</ul>
</div>
